import { getQueryString } from 'helpers/queryParams';

import { BASE_API_URL } from './index';

export const transactionsEndpoint = `${BASE_API_URL}/transactions/`;

export const getTransactionsEndpoint = (queryParams) => `${transactionsEndpoint}?${getQueryString(queryParams)}`;
